import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GET_CHILD_FUND_DROPDOWN_VALUES,
  GET_PARENT_FUND_DROPDOWN_VALUES,
  GET_FILETYPEMASTER,
  GET_ALLCHILD_FUND_DROPDOWN_VALUES,
  GET_FOLIO_DATA,
  GET_INVESTOR_DETAILS,
  SAVE_TRANSFAREE_DETAILS,
  GET_TRANSFER_VIEW_DETAILS,
  GET_TRANSFER_APPLICATIONS,
  GET_FUNDS_BYPAN,
  GET_TRANSFER_BYFOLIO,
  DISTRIBUTOR_PAN_MASTER_FORTRANSFER,
  GET_FINANCER_DETAILS,
  GET_INVESTOR_FOLIO_DATA,
  SAVE_PLEDGE_REQUEST_DETAILS,
  GET_PLEDGE_UNPLEDGE_DETAILS_BY_ID,
  SAVE_PMR_UPLOAD_COPY,
  GET_EXISTING_FINANCER,
  GET_UNPLEDGE_DETAILS_BY_ID,
  UPDATE_UNPLEDGE_REQUEST,
  GET_TOPUP_APPLICATIONS
} from '../../core/constants/api-endpoints';
import { environment } from '../../../environments/environment';
import {
  ACCESS_TOKEN,
  AUTHORIZATION,
  BEARER_TOKEN_PREFIX,
} from '../../core/constants/app-strings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  constructor(private http: HttpClient) { }

  getParentFund() {
    const url = environment.APIURL + GET_PARENT_FUND_DROPDOWN_VALUES;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getTransferDetails(transactionId: string): Observable<any> {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_TRANSFER_VIEW_DETAILS + `/${transactionId}`;
    return this.http.get<any>(url, { headers });
  }


  getPledgeUnpledgeDetails(requestId:string): Observable<any>{
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_PLEDGE_UNPLEDGE_DETAILS_BY_ID + `/${requestId}`;
    return this.http.get<any>(url, { headers });
  }


  getChildFundold(parentFundId) {
    const url =
      environment.APIURL + GET_CHILD_FUND_DROPDOWN_VALUES + '/' + parentFundId;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getChildFund(type: any) {
    var url;
    url = environment.APIURL + GET_ALLCHILD_FUND_DROPDOWN_VALUES + '/' + type;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getTransferId() {
    const url = environment.APIURL + GET_TRANSFER_APPLICATIONS;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }
  getFolioData(fundId: string, panNo: string) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(`${environment.APIURL}${GET_FOLIO_DATA}/${fundId}/${panNo}`, { headers });
  }
  getInvestorDetails(folioNo: string) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    const params = new HttpParams().set('folioNo', folioNo);
    return this.http.post(`${environment.MASTERAPIURL}${GET_INVESTOR_DETAILS}`, {}, {
      headers: headers,
      params: params
    });
  }

  saveTransfereeDetails(data: any) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    console.log('Before Sending Data', data);
    return this.http.post(
      `${environment.APIURL}${SAVE_TRANSFAREE_DETAILS}`,
      data,
      { headers }
    );
  }


  getAIFFund() {
    const url = environment.APIURL + GET_PARENT_FUND_DROPDOWN_VALUES;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getFileTypeMaster() {
    const url = environment.APIURL + GET_FILETYPEMASTER;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getTransferDetailsByFolio(body: any) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(`${environment.APIURL}${GET_TRANSFER_BYFOLIO}`, body, { headers });
  }

 getPledgeInvestorData(folioNo: string) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(`${environment.APIURL}${GET_INVESTOR_FOLIO_DATA}/${folioNo}`, { headers });
  }
  getFinancerMaster() {
    const url = environment.APIURL + GET_FINANCER_DETAILS;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }
  savePledgerequestDetails(data: any) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    return this.http.post(
      `${environment.APIURL}${SAVE_PLEDGE_REQUEST_DETAILS}`,
      data,
      { headers }
    );
  }

  savePMRCopy(data:any){
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    return this.http.post(
      `${environment.APIURL}${SAVE_PMR_UPLOAD_COPY}`,
      data,
      { headers }
    );
  }
  
  getExistingFinancers(folioNo:any) {
    const url = environment.APIURL + GET_EXISTING_FINANCER  + `/${folioNo}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getUnpledgeDetails(requestId:string): Observable<any>{
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_UNPLEDGE_DETAILS_BY_ID + `/${requestId}`;
    return this.http.get<any>(url, { headers });
  }

  updateUnpledgeRequest(data: any) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    return this.http.post(
      `${environment.APIURL}${UPDATE_UNPLEDGE_REQUEST}`,
      data,
      { headers }
    );
  }


  
  getDistributorPanDetailsForTransfer() {
    const url = environment.APIURL + DISTRIBUTOR_PAN_MASTER_FORTRANSFER;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
      return this.http.get(url, { headers });
  }

  /**
   * Get the funds (if any) in which the PAN owner has invested in
   * @param PAN 
   * @returns 
   */
  getFundsByPAN(PAN: string, fundId: string, transferId: number) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    const params = new HttpParams()
                      .set('PAN', PAN)
                      .set('FundId', fundId)
                      .set('transferId', transferId.toString());
    return this.http.get(`${environment.APIURL}${GET_FUNDS_BYPAN}`, { headers, params });
  }

  getTopupApplications(PAN: string, fundId: string) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders().set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${token}`);
    const body = {
      PAN: PAN,
      ChildFundId: fundId
    }
    return this.http.post<any>(`${environment.APIURL}${GET_TOPUP_APPLICATIONS}`, body, { headers });
  }
}
